import { GRADIENTS } from '../../../js/constants/styles'

export const OPEN_SANS_REGULAR = 'Open Sans'
export const SANS_SERIF = 'Sans-serif'

export const COLORS = Object.values(GRADIENTS).map((gradient) => gradient.TO.replace('#', ''))
